import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";

type LoadRealTimeProps = Parameters<typeof PopulateApiParameter>[0];

function CustomPopulateApiParameter(props: LoadRealTimeProps){
    const { onSuccess, ...apiParameter } = props.parameter;
    apiParameter.expand = ["warehouses"];
    props.apiParameter = apiParameter;
}

replaceInChain(
    chain,
    PopulateApiParameter,
    CustomPopulateApiParameter
);

